import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { useEntitlements } from '@utils/providers/entitlements-context.tsx';

/* eslint-disable no-restricted-syntax -- Semantic warning amber must stay stable across themes */
const BANNER_STYLE = {
  backgroundColor: '#fef3c7',
  color: '#92400e',
  borderBottom: '1px solid #fcd34d'
};
/* eslint-enable no-restricted-syntax */

/**
 * Upload Suspended Banner
 *
 * Shown while the organization may not start new transcription work. Existing
 * content stays fully available, so this explains why the Create button is
 * disabled rather than letting uploads fail with an error.
 *
 * Deliberately not dismissible: the state persists, and hiding it would leave
 * a disabled button with no explanation.
 */
export default function UploadSuspendedBanner() {
  const { t } = useTranslation();
  const { uploadSuspended } = useEntitlements();

  if (!uploadSuspended) {
    return null;
  }

  return (
    <div
      className="w-full px-4 py-2 flex items-center justify-center gap-2 text-sm font-medium"
      style={BANNER_STYLE}
      role="status"
    >
      <AlertTriangle className="h-4 w-4 flex-shrink-0" />
      <span>{t('uploading-suspended-banner')}</span>
    </div>
  );
}
